import { Activity } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project-imports
import NavUser from './NavUser';
import NavCard from './NavCard';
import Navigation from './Navigation';
import { useGetMenuMaster } from 'api/menu';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  return (
    <>
      <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
        <Navigation />
        {/* <Activity mode={drawerOpen && !downLG ? 'visible' : 'hidden'}>
          <NavCard />
        </Activity> */}
      </SimpleBar>
      {/* <NavUser /> */}
    </>
  );
}
